import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/es/reduxForm';
import formValueSelector from 'redux-form/es/formValueSelector';
import { initPasswordRecovery, navigateBackToLinkRequest } from 'actions/authentication';
import RequestPasswordReset from 'components/Credit24/LoanApplication/RequestPasswordResetAU';
import validateAU from 'utils/validation/au/validateAuthentication';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  navigateBackToLinkRequest: PropTypes.func.isRequired,
  initPasswordRecovery: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  recoveryEmail: PropTypes.string,
};

class RequestPasswordResetAUContainer extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    this.props.initPasswordRecovery(data.recoveryEmail);
  }

  render() {
    const { authentication, handleSubmit, recoveryEmail } = this.props;

    return (
      <form className="loan-form" onSubmit={handleSubmit(this.onSubmit)}>
        <div className="container container--mobile-fullWidth">
          <RequestPasswordReset
            authentication={authentication}
            recoveryEmail={recoveryEmail}
            navigateBackToLinkRequest={this.props.navigateBackToLinkRequest}
          />
        </div>
      </form>
    );
  }
}

RequestPasswordResetAUContainer.propTypes = propTypes;

const valueSelector = formValueSelector('request-password-reset-form');

export default reduxForm({
  form: 'request-password-reset-form',
  validate: validateAU,
  onSubmitFail: (errors, dispatch, submitErrors) => {
    if (DEBUG) {
      console.warn('form submit fail', errors, submitErrors);
    }
  },
  shouldValidate: () => true,
})(connect(
  (state) => ({
    authentication: state.authentication,
    recoveryEmail: valueSelector(state, 'recoveryEmail'),
  }),
  { navigateBackToLinkRequest, initPasswordRecovery }
)(RequestPasswordResetAUContainer));
